module.exports = __webpack_public_path__ + "img/bg_video3.6794ea30.jpg";